module.exports = ".padtop10 {\n  padding-top: 10px; }\n\n.allcaps {\n  text-transform: uppercase; }\n\n.top-margin {\n  margin-top: 48px; }\n\n/*.display-content {\r\n  padding-top: 24px !important;\r\n}*/\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-settings/my-settings.component.scss
// module id = ./src/app/pages/client/my-settings/my-settings.component.scss
// module chunks = main